import ContactMailOutlinedIcon from "@mui/icons-material/ContactMailOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";

import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
	clearSelectedClient,
	clearSelectedAccountant,
	clearSelectedTaxYear,
} from "../../../store/actions";
export const ClientRoutesComponent = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const clearClientId = () => {
		dispatch(clearSelectedClient());
	};
	const clearClientName = () => {
		// dispatch(clearSelectedClientName());
		dispatch(clearSelectedClient());
	};
	const clearAccountantId = () => {
		dispatch(clearSelectedAccountant());
	};
	const clearAccountantName = () => {
		// dispatch(clearSelectedAccountantName());
		dispatch(clearSelectedAccountant());
	};
	const clearTaxYear = () => {
		dispatch(clearSelectedTaxYear());
	};
	const ArrayData = [
		{
			label: "Home",
			// icon: <HomeOutlinedIcon />,
			expanded: true,
			items: [
				{
					label: "Dashboard",
					command: () => {
						navigate("/clients/dashboard");
					},
				},
				{
					label: "Client List",
					command: () => {
						clearClientId();
						clearClientName();
						clearTaxYear();
						// clearRefNo();
						navigate("/clients");
					},
				},
			],
		},
		// {
		// 	label: "Maintain",
		// 	icon: <ContactMailOutlinedIcon />,
		// 	items: MaintainMenu,
		// },
		// {
		// 	label: "Maintain",
		// 	icon: <ContactMailOutlinedIcon />,
		// 	items: MaintainMenu,
		// },
		// {
		// 	label: "User Management",
		// 	icon: <ListAltOutlinedIcon />,
		// 	items: [],
		// },
		{
			label: "Reports",
			// icon: <ListAltOutlinedIcon />,
			items: [],
		},
	];
	return {
		ClientRoutes: ArrayData,
	};
};
